/**
 * Optional per-activity calendar overrides live on events/{id}.activityDates (YYYY-MM-DD or Timestamp).
 * Default weekday for each activity when no override is set (relative to events.date = Saturday).
 */

export const ACTIVITY_DEFAULT_SCHEDULE_DAY = {
  furyLab: 'thursday',
  recurrency: 'wednesday',
  waterTrainingThursday: 'thursday',
  waterTrainingFriday: 'friday',
  canopyThursday: 'thursday',
  canopyFriday: 'friday',
  highAltitude: 'sunday',
};

/** Schedule column ids for optional events/{id}.scheduleDayDates (Monday = after party, Sat + 2) */
export const SCHEDULE_DAY_IDS = ['wednesday', 'thursday', 'friday', 'saturday', 'sunday', 'monday'];

export const SCHEDULE_DAY_LABELS = {
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday (main competition)',
  sunday: 'Sunday',
  monday: 'Monday (after party)',
};

/** Admin UI: optional activityDates fields */
export const ACTIVITY_OVERRIDE_FIELDS = [
  { key: 'recurrency', label: 'Recurrency', hint: 'Default: Wednesday of event week' },
  { key: 'furyLab', label: 'Fury Lab', hint: 'Default: Thursday' },
  { key: 'waterTrainingThursday', label: 'Water training (Thursday)', hint: 'Default: Thursday' },
  { key: 'waterTrainingFriday', label: 'Water training (Friday)', hint: 'Default: Friday' },
  { key: 'canopyThursday', label: 'Canopy course (Thursday)', hint: 'Default: Thursday' },
  { key: 'canopyFriday', label: 'Canopy course (Friday)', hint: 'Default: Friday' },
  { key: 'highAltitude', label: 'High altitude loads', hint: 'Default: Sunday' },
];
